import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IgxGridComponent, IgxGridModule, IgxTabsModule } from '@infragistics/igniteui-angular';
import { FormGridTest } from '../grid-form/grid/form.component';

@Component({
  selector: 'app-grid-space-test',
  standalone: true,
  imports: [CommonModule, FormsModule, IgxGridModule, IgxTabsModule, IgxGridComponent, FormGridTest],
  templateUrl: './grid-space-test.component.html',
  styleUrl: './grid-space-test.component.scss',
})
export class GridSpaceTestComponent {
  public testGrid: IgxGridComponent;
  contacts: IData[] = [
    { id: 1, name: 'Name 1' },
    { id: 2, name: 'Name 2' },
    { id: 2, name: 'Name 3' },
  ];
}

export interface IData {
  id: number;
  name: string;
}
